import { request } from '../utils/request';

export const processUpsertUsersApi = params =>
  request.post('/admin/refresh-es-document', params);
